export const EMAIL_TYPE_DESCRIPTION_MAX_LENGTH = 1000;
